// apps/api/src/qxcircle/qxcircle-share-action.ts
// Description: QXCircle share payload helper — keeps service under line cap.
// Owner: Masa Bayu
// Date: 2026-08-24

import type { QxCircleFeedPost, QxCircleShareResult } from "./qxcircle.types";

export function shareQxCirclePostRecord(
  post: QxCircleFeedPost,
  originRaw?: string,
): QxCircleShareResult {
  post.shareCount += 1;
  const sharePath = `/circle?post=${encodeURIComponent(post.id)}`;
  const origin =
    originRaw?.trim().replace(/\/+$/, "") || "http://localhost:5173";
  const snippet = post.body.trim().slice(0, 80);
  const text = snippet
    ? `${post.authorName} on QXRead QXCircle — ${snippet}`
    : `${post.authorName} on QXRead QXCircle`;
  return {
    postId: post.id,
    sharePath,
    shareUrl: `${origin}${sharePath}`,
    title: "QXRead QXCircle",
    text,
    authorName: post.authorName,
    shareCount: post.shareCount,
  };
}
